// src/pages/consultationrequest/ConsultationRequestList.jsx

import React from "react";
import ConsultationRequestCard from "./ConsultationRequestCard";
import { useTranslation } from "react-i18next";

const ConsultationRequestList = ({

    consultations = [],
    mode,
    loading = false,
    currentUser,
    isAdmin,
    onView,
    onEdit,
    onDelete

}) => {

    const { t } = useTranslation();


    // ============================================================
    // CHARGEMENT
    // ============================================================

    if (loading) {

        return (
            <div className="text-center py-5">

                <div
                    className="spinner-border text-success"
                    role="status"
                >

                    <span className="visually-hidden">
                        {t("consultationRequest.loading")}
                    </span>

                </div>

            </div>
        );
    }


    // ============================================================
    // AUCUNE DONNÉE
    // ============================================================

    if (!consultations?.length) {

        return (
            <div className="alert alert-info">

                <i className="bi bi-info-circle me-2"></i>

                {t("consultationRequest.noData")}

            </div>
        );
    }


    // ============================================================
    // TITRE
    // ============================================================

    let title;

    if (isAdmin) {

        title = `${consultations.length} ${t(
            "consultationRequest.titleAdmin",
            "Consultations"
        )}`;

    }
    else if (mode === "RECEIVER") {

        title = `${consultations.length} ${t(
            "consultationRequest.titleReceiver"
        )}`;

    }
    else {

        title = `${consultations.length} ${t(
            "consultationRequest.titleSender"
        )}`;
    }


    // ============================================================
    // AFFICHAGE
    // ============================================================

    return (
        <>

            {/* ====================================================
                HEADER
            ==================================================== */}

            <div className="d-flex justify-content-between align-items-center mb-3">

                <h5 className="mb-0">

                    <i className="bi bi-chat-dots me-2"></i>

                    {title}

                </h5>

            </div>


            {/* ====================================================
                LISTE DES CONSULTATIONS
            ==================================================== */}
            <div className="row">
                {consultations.map((consultation) => (
                    <div
                        key={consultation.id}
                        className="col-lg-6 mb-4"
                    >
                        <ConsultationRequestCard

                            request={consultation}

                            mode={mode}

                            currentUser={currentUser}

                            isAdmin={isAdmin}

                            onView={onView}

                            onEdit={onEdit}

                            onDelete={onDelete}

                        />

                    </div>

                ))}

            </div>

        </>
    );
};


export default ConsultationRequestList;